import Signup from '../login/Signup';

function SignupLayout() {
  return (
    <Signup />
  )
}

export default SignupLayout
